<template>
  <section class="page-base__all">
    <sc-page-loading v-if="loading" />

    <div class="page-base__btn-back" v-if="showBack || showBackText" @click="back">
      <div><sc-icon pack="fas" icon="chevron-left" size="is-small"/></div>
      <div class="page-base__btn-back__text">{{ showBackText }}</div>
    </div>

    <h1
      class="page-base__title has-text-primary"
      v-if="title">{{ title }}
    </h1>

    <div v-if="!title" class="page-base__title has-text-primary has-text-weight-bold">
      <div><slot name="titleLeft"></slot></div>
      <div><slot name="titleRight"></slot></div>
    </div>

    <h2
      class="subtitle"
      v-if="subTitle">
      <span v-if="openSubtitle">{{subTitle}} <a v-if="openSubtitle" @click="openSubtitle = false">Ocultar</a></span>
      <a
        v-if="!openSubtitle"
        @click="openSubtitle = !openSubtitle"
      >Saiba mais</a>
    </h2>

    <slot name="subtitleSection" v-if="!subTitle"></slot>

    <div class="page-content" :class="{'box': box}">
      <slot></slot>
    </div>
  </section>
</template>

<script>
import {
  ScIcon,
  ScPageLoading,
} from '@intelipost-js/secure-components';

export default {
  name: 'new-page-base',
  props: {
    /**
     * Título da página, usando a tag **h1**
     */
    title: {
      type: String,
    },
    /**
     * SubTítulo da página, usando a tag **h2**
     */
    subTitle: {
      type: String,
    },
    /**
     * Mostra um loading no bloco da página
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Coloca a class **box** no content da página, assim cria um box com fundo branco e padding
     */
    box: {
      type: Boolean,
      default: false,
    },
    /**
     * Mostrar botão de voltar
     */
    showBack: {
      type: Boolean,
      default: false,
    },
    showBackText: {
      type: String,
    },
  },
  data() {
    return {
      openSubtitle: true,
    };
  },
  methods: {
    back() {
      this.$emit('back');
    },
  },
  components: {
    ScPageLoading,
    ScIcon,
  },
};
</script>

<style lang="scss" scoped>
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

.page-base__all {
  margin: 1em;
}

.subtitle {
  margin-top: -0.75rem !important;
}

.page-base__title {
  font-size: 20px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.page-base__btn-back {
  color: $primary;
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;

  &__text {
    margin-left: .5em;
    font-size: 16px;
   
    &:hover {
      cursor: pointer;
    }
  }
}

.page--loading{
  position: absolute;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .page-base__title{
    font-size: 1.4rem;
  }
}
</style>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/components/new-page-base/NewPageBase.vue?3cbc5bc4